exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-method-item[data-v-3639a800] {\n  padding: 10%;\n}\n.payment-method-item[data-v-3639a800]:hover {\n  border: 2px solid #105fbd !important;\n}", ""]);

// exports
